import { useEffect, useState } from "react";

import HintModal from "../common/hint-modal";

import useGetCalendars, { useGetIntegrateCalendars } from "./hooks/useCalendars";

import "./calendar.css";

const Calendars = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];
  const { data, _refetch } = useGetCalendars();
  const [connection, setConnection] = useState(null);
  const { data: integrateCalendars, refetch: _integrateCalendarsRefetch } =
    useGetIntegrateCalendars(connection);

  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };
  //   const [calendarData, setCalendarData] = useState()

  //   useEffect(() => {
  //     if (data) {
  //       setCalendarData(data)
  //     }
  //   },[data])

  useEffect(() => {
    if (integrateCalendars) {
      window.location.href = integrateCalendars?.auth_url;
    }
  }, [integrateCalendars]);

  const calendars = [
    {
      calendar: "Outlook",
      active: data?.microsoft_outlook_calendar?.active,
      lastLogin:
        data?.microsoft_outlook_calendar?.logged_in_at?.toLocaleString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }) || "N/A",
      connect: "Integrate",
      connection: "outlook",
    },
    {
      calendar: "Google",
      active: data?.google_calendar_obj?.active,
      lastLogin:
        new Date(data?.google_calendar_obj?.logged_in_at).toLocaleString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }) || "N/A",
      connect: "Integrate",
      connection: "google_calendar",
    },
  ];

  const handleConnect = (connection) => {
    setConnection(connection);
  };
  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div
        className="d-flex justify-content-end m-b-5"
        onClick={() => {
          handleHintToggle();
        }}
      >
        <i className="ic ic-19 ic-help-2 cursor-pointer" />
      </div>
      <div className="col-lg-12 m-t-5">
        <table className="table">
          <thead className="">
            <tr>
              <th className="text-center" id="calendar-id-firm-settings">
                Calendar
              </th>
              <th className="text-center" id="calendar-id-firm-settings">
                Active
              </th>
              <th className="text-center" id="calendar-id-firm-settings">
                Firm User
              </th>
              <th className="text-center" id="calendar-id-firm-settings">
                Last Login
              </th>
              <th className="text-center" id="calendar-id-firm-settings">
                Connect
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              calendars?.map((calendarItem, idx) => (
                <tr key={idx} id="calendar-id-firm-settings-border">
                  <td id="calendar-id-firm-settings">
                    <span className="calendar-section">
                      <span className="calendar-header" style={{ fontSize: "14px" }}>
                        {calendarItem.calendar}
                      </span>
                    </span>
                  </td>
                  <td id="calendar-id-firm-settings">
                    <input type="radio" checked={calendarItem.active} readOnly />
                  </td>
                  <td id="calendar-id-firm-settings">
                    <div className="d-flex align-items-center justify-content-center">
                      {data?.profile_pic ? (
                        <span className="firm-user">
                          <span className="user-image m-r-5">
                            <img src={data?.profile_pic} alt={data?.firm_user} />
                          </span>
                        </span>
                      ) : (
                        <span className="ic ic-26 ic-avatar" />
                      )}
                      {data?.firm_user}
                    </div>
                  </td>
                  <td id="calendar-id-firm-settings">{calendarItem.lastLogin}</td>
                  <td
                    id="calendar-id-firm-settings"
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "86px" }}
                  >
                    <button
                      onClick={() => handleConnect(calendarItem.connection)}
                      className="btn btn-primary btn_length height-25 d-flex py-0"
                    >
                      {calendarItem.connect}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default Calendars;
